import { createApp } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import App from './App.vue'
import router from './router'
import store from './store'
import VuePapaParse from 'vue-papa-parse'
import VueCookies from 'vue3-cookies'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-free/js/all.min'
import 'leaflet/dist/leaflet.css'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import 'leaflet/dist/leaflet'
import 'leaflet-routing-machine/dist/leaflet-routing-machine'

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'

createApp(App).directive('observe-visibility', {
  beforeMount: (el, binding, vnode) => {
    vnode.context = binding.instance
    ObserveVisibility.bind(el, binding, vnode)
  },
  update: ObserveVisibility.update,
  unmounted: ObserveVisibility.unbind,
}).use(store).use(VueCookies).use(router).use(VuePapaParse).mount('#app')
